
import saMessages from '../locales/ru_RU';

const saLang = {
    messages: {
        ...saMessages
    },
    locale: 'ru-RU',
 
};
export default saLang;